import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class PersonalExpenseType extends Enum {
  static RENT = {
    key: 'rent',
    get value() {
      return Lang.t('liability.rent');
    }
  };

  static SUBSCRIPTIONS = {
    key: 'subscriptions',
    get value() {
      return Lang.t('liability.subscriptions');
    }
  };

  static UTILITIES = {
    key: 'utilities',
    get value() {
      return Lang.t('liability.utilities');
    }
  };

  static CAR_LEASE = {
    key: 'car_lease',
    get value() {
      return Lang.t('liability.car-lease');
    }
  };

  static OTHER = {
    key: 'other',
    get value() {
      return Lang.t('asset.other');
    }
  };
}
